import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';


@Component({
    selector: 'privilege-cell',
    standalone: true,
    imports: [CommonModule],
    template: `
    <div [ngClass]="{'blocked': data === 'Blocked', 'unblocked': data === 'Unblocked'}" class="cell-text">
      {{ data }}
    </div>
  `,
    styles: [
        `
    .cell-text {
        font-family: var(--manrope);
        font-weight: 500;
        font-size: 16px;
      }
      .blocked {
        color: var(--brand-destructive);
      }
      .unblocked {
        color: var(--text-secondary);
      }
    `,
    ],
})
export class PrivilegeCellComponent {
    @Input() data: any;
}
